module.exports = __webpack_public_path__ + "static/media/53_B.7cfd3a5a.png";